import React from "react";
import KdesuLogoSvg from "./KdesuLogo.svg?react";

interface KdesuLogoProps {
  size?: number;
}

const DEFAULT_SIZE = 24;

const KdesuLogo: React.FC<KdesuLogoProps> = ({ size = DEFAULT_SIZE }) => (
  <KdesuLogoSvg width={size} height={size} aria-hidden="true" />
);

export default KdesuLogo;
